export function normalizeLayerUrl(url?: string | null): string | null {
  return url ? url.replace(/\/+$/, "") : null;
}